module.exports = __webpack_public_path__ + "static/media/image6.ac21adb9.jpeg";